// AnalyticsSidebar — Renders the unified ChatSidebar on non-AI pages.
// Shows dashboard navigation, DashAI action shortcuts, and user profile.
// Chat sessions are empty (users navigate to /ai to see them).
// Shares collapse state with DashAI's sidebar via localStorage.

import "../features/dashai/index.css";
import { useState, useCallback } from "react";
import { ChatSidebar } from "@dashai/components/dashai/ChatSidebar";

import { useAnalyticsNavActions } from "../hooks/useAnalyticsNavActions";

const SIDEBAR_COLLAPSE_KEY = "dashone-sidebar-collapsed";

export default function AnalyticsSidebar() {
  const navActions = useAnalyticsNavActions();

  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_COLLAPSE_KEY) === "true";
    } catch {
      return false;
    }
  });

  const handleToggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSE_KEY, String(next));
      } catch {
        // Storage refuses in private mode and past quota; the state still holds for this visit.
      }
      return next;
    });
  }, []);

  return (
    <div className="dashai-scope h-full">
      <ChatSidebar
        {...navActions}
        sessions={[]}
        currentChatId={null}
        isCollapsed={collapsed}
        onToggleCollapse={handleToggle}
        onDeleteChat={() => {}}
      />
    </div>
  );
}
